import { Link } from 'react-router-dom';

export default function AboutTeaser() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <span className="text-xs text-primary-500 font-label bg-primary-50 px-3 py-1 rounded-full">
              关于我们
            </span>
            <h2 className="text-xl md:text-3xl font-heading font-semibold text-foreground-900 mt-3 mb-4">
              白洁情感文学精选
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              我们致力于为都市情感文学爱好者提供高质量的阅读体验。以少妇白洁系列为核心，我们从故事赏析、人物解读、情感话题和文学评论等多个维度，深入探讨当代女性的情感世界。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              每一篇文章都经过编辑团队精心打磨，力求在文学性与可读性之间取得完美平衡，为读者带来既有深度又有温度的内容。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-label transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              了解更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="flex-1">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20a%20comfortable%20armchair%20and%20stack%20of%20books%2C%20warm%20evening%20light%20from%20a%20floor%20lamp%2C%20soft%20throw%20blanket%2C%20elegant%20interior%2C%20cream%20and%20amber%20tones%2C%20peaceful%20feminine%20atmosphere%2C%20shallow%20depth%20of%20field&width=700&height=500&seq=about-teaser-baijie&orientation=landscape"
                alt="白洁情感文学精选"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}